import { CommonEnums } from '../../common.enums';
import { TEmail_Inst } from './temail_inst';
import { Flagent } from '../datapoint/flagent';
import { Flagent_Grp } from '../datapoint/flagent_grp';

export class TaskEmail {
    tEmail_Inst: TEmail_Inst;
    flagent: Flagent;
    flagent_Grp: Flagent_Grp;
    change_Ind: string;
    error_Cd: string;;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.tEmail_Inst = new TEmail_Inst();
        this.flagent = new Flagent();
        this.flagent_Grp = new Flagent_Grp();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
    }

    static parse(taskEmailTmp: TaskEmail): TaskEmail {
        let taskEmail: TaskEmail = new TaskEmail();
        taskEmail.copyFrom(taskEmailTmp);
        return taskEmail;
    }

    copy(): TaskEmail {
        let taskEmailTmp: TaskEmail = new TaskEmail();

        taskEmailTmp.tEmail_Inst = this.tEmail_Inst.copy();
        taskEmailTmp.flagent = this.flagent.copy();
        taskEmailTmp.flagent_Grp = this.flagent_Grp.copy();
        taskEmailTmp.change_Ind = this.change_Ind;
        taskEmailTmp.error_Cd = this.error_Cd;
        taskEmailTmp.error_Msg = this.error_Msg;
        taskEmailTmp.ref_Id = this.ref_Id;
        taskEmailTmp.ref_Cd = this.ref_Cd;
        taskEmailTmp.fldr_Id = this.fldr_Id;

        return taskEmailTmp;
    }

    copyFrom(taskEmailTmp: TaskEmail): void {
        this.tEmail_Inst.copyFrom(taskEmailTmp.tEmail_Inst);
        this.flagent.copyFrom(taskEmailTmp.flagent);
        this.flagent_Grp.copyFrom(taskEmailTmp.flagent_Grp);
        this.change_Ind = taskEmailTmp.change_Ind;
        this.error_Cd = taskEmailTmp.error_Cd;
        this.error_Msg = taskEmailTmp.error_Msg;
        this.ref_Cd = taskEmailTmp.ref_Cd;
        this.ref_Id = taskEmailTmp.ref_Id;
        this.fldr_Id = taskEmailTmp.fldr_Id;
    }

    compare(taskEmailTmp: TaskEmail): string {
        let diffString ='';

         diffString = (this.tEmail_Inst).compare(taskEmailTmp.tEmail_Inst);
        if (diffString != '') return diffString;

        return diffString;
    }

    tostring(): string {
        return "TaskEmail [tEmail_Inst=" + this.tEmail_Inst.toString() +
            ", flagent_Grp=" + this.flagent_Grp.toString() +
            ", flagent=" + this.flagent.toString() +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Cd=" + this.ref_Cd +
            ", ref_Id=" + this.ref_Id +
            ", fldr_Id=" + this.fldr_Id + "]"
    }
}
